import { Flex, Text } from "@unifize/sarah";

type SubscriptionDetailFieldProps = {
  label: string;
  value: string | number;
};

const SubscriptionDetailField = ({
  label,
  value,
}: SubscriptionDetailFieldProps) => {
  return (
    <Flex direction="column" gap="0.75rem" items="flex-start">
      <Flex direction="column" gap="0.25rem" items="flex-start">
        <Text variant="body" weight="regular" color="#667085">
          {label}
        </Text>
        <Text variant="body" weight="regular" color="#111827">
          {value}
        </Text>
      </Flex>
    </Flex>
  );
};

export default SubscriptionDetailField;
